import { rpc } from "src/composables/Rpc";
import { Guid } from "src/interfaces/InleagueApiV1";

export const getInitiallySelectedSeasonMenuOption = rpc<void, {seasonUID: Guid | ""}>("get", "v1/waitlistManager/getInitiallySelectedSeasonMenuOption")
